<template>
	<div class="field">
		<label class="timerange"><span>Beginn:</span><span class="divider"></span><span>Ende:</span></label>
		<div class="wrapper">
			<div class="outputcontainer" @click="toggleCalendar">
				<div class="outputitem">{{ getDateString(timerange.start) }} <br> {{ getTimeString(timerange.start) }}</div>
				<div :class="'outputitem button' + buttonClass"></div>
				<div class="outputitem">{{ getDateString(timerange.end) }} <br> {{ getTimeString(timerange.end) }}</div>
			</div>
			<div class="" :style="{ display: datePickerDisplay }">
				<date-picker
					v-model="timerange"
					:masks="masks"
					mode="dateTime"
					is-range
					is24hr
					:minute-increment="intervalMinutes"
					:min-date="minDate"
					:max-date="maxDate"
					@change="checkTimerange"
					@click="checkTimerange"
					is-expanded
					title-position="center"
					trim-weeks
				></date-picker>
			</div>	
		</div>
	</div>
</template>

<script>
import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';
import config from '../config';
import helpers from '../helpers';

export default {
	components: {
		DatePicker
	},
	data() {
		return {
			timerange: this.$store.getters.getTimerange,
			timerangeUsed: null,
			intervalMinutes: config.timerange.intervalMinutes,
			minDate: helpers.addMinutesToNow(60 * 24),
			maxDate: helpers.addMinutesToNow(60 * 24 * config.timerange.maxAdvanceDays),
			datePickerDisplay: 'none',
			buttonClass: '',
			masks: {
				weekdays: 'WW'
			}
		}
	},
	methods: {
		checkTimerange() {
			setTimeout(() => {
				if (this.timerange !== this.timerangeUsed) {
					// if (this.timerange.start == this.timerange.end) {
					// 	this.timerange.end = helpers.addMinutes(this.timerange.start, this.intervalMinutes);
					// }
					this.$store.commit('setTimerange', this.timerange);
					this.$store.dispatch('updatePrices');
					this.timerangeUsed = this.timerange;
				}
			}, 100); // in firefox, time change takes effect only after event is emitted (?)
		},
		getTimeString(date) {
			function pad(num) {
				return ('0' + num).substr(-2,2);
			}
			return pad(date.getHours()) + ':' + pad(date.getMinutes());
		},
		getDateString(date) {
			function pad(num) {
				return ('0' + num).substr(-2,2);
			}
			return pad(date.getDate()) + '.' + pad(date.getMonth()+1) + '.' + pad(date.getYear());
		},
		toggleCalendar() {
			if (this.datePickerDisplay === 'none') {
				this.datePickerDisplay = 'block';
				this.buttonClass = ' close'
			} else {
				this.datePickerDisplay = 'none';
				this.buttonClass = ''
			}
		} 
	}
}
</script>

<style lang="scss">

label.timerange {
	display: flex;
	justify-content: space-evenly;
	margin: 0 0 5px;
}
label.timerange .divider {
	display: inline-block;
	width: 38px;
}

.wrapper {
	border: 1px solid $color-input-border;
	border-radius: 15px;
}

.outputcontainer {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	cursor: pointer;
}
.outputitem {
	color: $color-input-text;
	font-weight: bold;
	padding: .7rem;
	line-height: 1.4rem;
	text-align: center;
}
.button {
	background-image: $icon-arrow;
	background-position-y: 0;
	background-position-x: center;
	width: 38px;
	height: 38px;
}
.button.close {
	transform: rotate(180deg);
}

.vc-container {
	width: 100%;
	margin-bottom: 12px;
	border: none !important;
	font-family: $fontfamily !important;
	background: none;
}
.vc-title {
	color: $color-input-text !important;
	font-size: 1rem !important;
	&:hover, :active {
		color: $color-text !important;
		opacity: 1 !important;
	}
}
.vc-arrow {
	color: $color-text !important;
}
.vc-arrow:hover {
	background-color: $color-timeselect-bg !important;
}
.vc-pane-layout {
	margin-bottom: 1px;
}
.vc-weekday {
	color: $color-text !important;
}
.vc-highlight {
	border-color: $color-input-border !important;
}
.vc-highlight:hover {
	background-color: $color-timeselect-bg !important;
}
.vc-focusable {
	font-weight: bold !important;
}
.is-disabled {
	font-weight: normal !important;
}
.vc-nav-popover-container {
	border: none !important;
	box-shadow: 2px 5px 15px lightgrey !important;
	background-color: $color-header-bg !important;
	color: white !important;
}
.vc-nav-title {
	font-weight: bold !important;
}
.vc-nav-item.is-active {
	color: $color-text !important;
	background-color: white !important;
}
.vc-nav-item.is-disabled {
	opacity: 1 !important;
}
.vc-time-icon {
	display: none;
}
.vc-time-picker {
	border: none !important;
	padding: 0 8px 4px !important;
}
.vc-time-picker:first-child .vc-time-content::before {
	content: 'Beginn:';
	text-transform: none;
	font-weight: normal;
	font-size: 14px !important; //fixed size to prevent layout explosion
	color: $color-label;
	margin-right: .1rem;
	width: 50px;
}
.vc-time-picker:nth-child(2) .vc-time-content::before {
	content: 'Ende:';
	text-transform: none;
	font-weight: normal;
	font-size: 14px !important; //fixed size to prevent layout explosion
	color: $color-label;
	margin-right: .1rem;
	width: 50px;
}
.vc-time-content {
	font-size: 14px !important; //fixed size to prevent layout explosion
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
}
.vc-time-date {
	margin-top: 3px !important;
	margin-right: 5px !important;
}
.vc-time-date * {
	margin-top: 1px; 
	font-weight: bold;
	color: $color-text !important;
	text-transform: none;
}
.vc-time-select span {
	font-size: 14px !important; //fixed size to prevent layout explosion
	font-weight: bold !important;
	color: $color-value !important;
}
.vc-select select {
	border-radius: 18px !important;
	font-size: 14px !important; //fixed size to prevent layout explosion
	font-weight: bold !important;
	color: $color-value !important;
	background-color: $color-timeselect-bg !important;
	border: none !important;
}
.vc-select-arrow {
	color: $color-value !important;
}
.vc-time-weekday::after, .vc-time-day::after, .vc-time-month::after {
	content: '.' !important;
}
.vc-time-day {
	order: 1;
}
.vc-time-month {
	order: 2;
	margin-left: 3px !important;
}
.vc-time-year {
	order: 3;
	margin-left: 3px !important;
}
</style>
